<section class="header">
  <edge-global-header></edge-global-header>
</section>

<edge-articles-main *ngIf="showNews" [newsArticles]="newsArticles$ | async"></edge-articles-main>

<section class="footer">
  <edge-global-footer></edge-global-footer>
</section>